import React, { Fragment, useCallback, useEffect, useRef } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { Link, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import {
  clearRewardCreated,
  clearRewardRemoved,
  clearRewardUpdated,
  getListRewards,
  clearListRewards,
} from "../../../store/dashboard/Rewards/actions";

import {
  DEFAULT_LIMIT,
  DEFAULT_OFFSET,
} from "../../../constants/pagination";
import Placeholder from "../../../components/Common/Placeholder";
import InfiniteScroll from "../../../components/Common/InfinitScroll";
import useSnackbarState from "../../../hooks/useSnackbarState";
import RewardTableRow from "./components/RewardTableRow";
import withUploadingError from "../../../HOCs/withUploadingError";

import styles from "../dashboard.module.scss";
import SEO from "../../../components/Common/SEO";

const Bundles = ({
  clearRewardCreated,
  rewards,
  getListRewards,
  clearRewardUpdated,
  clearRewardRemoved,
  clearListRewards,
}) => {
  const { data, created, updated, removed, pagination, loading } = rewards;
  const scrollRef = useRef(null);
  const fetchList = (nextPagination = {}) => {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = nextPagination;
    getListRewards({ model: { limit, offset } });
  };

  const [isUpdated] = useSnackbarState(updated, clearRewardUpdated);
  const [isCreated] = useSnackbarState(created, clearRewardCreated);

  const loadMore = useCallback((offset) => fetchList({ offset }), []);

  useEffect(() => {
    // perform effect if entity appears
    if (removed) {
      fetchList({ limit: DEFAULT_LIMIT, offset: DEFAULT_OFFSET });
      clearRewardRemoved();
    }
  }, [removed]);

  useEffect(() => {
    // Fetch data
    fetchList();

    return () => {
      clearRewardRemoved();
      clearListRewards();
    };
  }, []);

  return (
    <>
      <SEO title="Rewards" />
      <Row className="page-content h-100">
        <Container fluid className="h-100">
          <Row>
            <Col xs="12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">REWARDS</h4>
              </div>
            </Col>
          </Row>
          {isCreated && (
            <Row>
              <Col xs="12">
                <Alert color="success">
                  New reward has been successfully created
                </Alert>
              </Col>
            </Row>
          )}
          {isUpdated && (
            <Row>
              <Col xs="12">
                <Alert color="success">
                  The reward has been successfully updated
                </Alert>
              </Col>
            </Row>
          )}
          <Card className={styles.cardFullsize}>
            <CardBody>
              <CardTitle className="d-flex flex-row justify-content-between pb-3">
                <div className={styles.header}>
                  {/* Category: {item && item.name} */}
                </div>
                <Link to={`/rewards/create`}>
                  <Button color="primary">Create reward</Button>
                </Link>
              </CardTitle>
              <CardText tag={"div"}>
                <Row className="h-100 scrollbar-wrapper">
                  {!loading && !data.length && (
                    <Placeholder text="no reward created" />
                  )}
                  <InfiniteScroll
                    className="w-100 h-100"
                    ref={scrollRef}
                    disabled={data?.length === 0 || loading}
                    offset={pagination.nextOffset}
                    nextOffset={pagination.nextOffset}
                    totalCount={pagination.totalCount}
                    loadMore={loadMore}
                  >
                    {!!data && !!data.length > 0 && (
                      <div className="table-responsive col-12">
                        <Table className="table mt-0 mb-0 border-bottom">
                          <thead className="thead-light">
                            <tr>
                              <th>Reward Name</th>
                              <th className="w-220px text-right pr-5">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((reward, index) => (
                              <Fragment key={"table-item-" + index}>
                                <RewardTableRow reward={reward} />
                              </Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}
                    {loading &&
                      !!data.length &&
                      data.length < pagination.totalCount && (
                        <Col xs={12}>
                          <div className="text-center my-3">
                            <div className="text-success">
                              <i className="bx bx-loader bx-spin font-size-18 align-middle mr-2" />{" "}
                              Load more
                            </div>
                          </div>
                        </Col>
                      )}
                  </InfiniteScroll>
                </Row>
              </CardText>
            </CardBody>
          </Card>
        </Container>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  const { Rewards } = state;

  return { rewards: Rewards };
};

export default withUploadingError(
  connect(mapStateToProps, {
    clearRewardCreated,
    clearRewardUpdated,
    getListRewards,
    clearRewardRemoved,
    clearListRewards,
  })(Bundles)
);
